import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';

import jwTrophyOnly from '../../../assets/images/jw-trophy_only-50x50.png';
// import jwlogo from '../../../assets/images/jw-logo.png';
import css from './JWFooter.module.scss';
import toJS from '../../../lib/hocs/toJS';

const styles = theme => ({
  // phoneLinks: {
  //   color: '#2e7da1 !important',
  // },
  // mobilePoweredBy: {
  //   color: '#2e7da1 !important',
  // },
  mobileLogo: {
    [theme.breakpoints.down('sm')]: {
      marginTop: -8,
    },
  },
});

const JWFooter = ({
  organization,
  canEditOrganization,
  isEditingOrganization,
  classes,
}) => {
  const copyrightName = organization ? organization.name : 'Jersey Watch';
  return (
    <div style={{ fontFamily: 'Anton, sans-serif' }}>
      <Hidden smUp>
        {/* phone */}
        <div style={{ marginBottom: canEditOrganization ? 56 : 0 }}>
          {!isEditingOrganization && (
            <Grid
              className={css.container}
              container
              style={{ padding: 12, textTransform: 'none' }}
            >
              <Grid item xs={12} className={classes.mobilePoweredBy}>
                <Grid item xs={12} sm={12}>
                  <a
                    href="https://www.jerseywatch.com/?utm_source=jw_wa"
                    rel="nofollow"
                  >
                    <span style={{ fontSize: 14 }}>Website Powered By</span>
                    <br />
                    <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <span style={{ fontSize: 18 }}>Jersey Watch</span>
                      <img
                        src={jwTrophyOnly}
                        style={{ width: 30, height: 30, marginLeft: 4 }}
                        alt="Jersey Watch"
                      />
                    </div>
                  </a>
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ margin: 8 }}>
                © {copyrightName}
              </Grid>
              <Grid item xs={12}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    marginTop: 8,
                    fontSize: 14,
                    gap: 8,
                  }}
                >
                  <a href="/terms_of_use" className={classes.phoneLinks}>
                    Terms Of Use
                  </a>
                  <a href="/privacy_policy" className={classes.phoneLinks}>
                    Privacy Policy
                  </a>
                  <a href="/cookie_policy" className={classes.phoneLinks}>
                    Cookie Policy
                  </a>
                </div>
              </Grid>
            </Grid>
          )}
        </div>
      </Hidden>
      <Hidden xsDown mdUp>
        {/* tablet */}
        <div style={{ marginBottom: canEditOrganization ? 64 : 0 }}>
          {!isEditingOrganization && (
            <Grid
              className={css.container}
              container
              style={{ textTransform: 'none', padding: 12 }}
            >
              <Grid item sm={6}>
                <div>© {copyrightName}</div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: 8,
                    gap: 16,
                    fontSize: 14,
                  }}
                >
                  <a href="/terms_of_use" className={classes.phoneLinks}>
                    Terms Of Use
                  </a>
                  <a href="/privacy_policy" className={classes.phoneLinks}>
                    Privacy Policy
                  </a>
                  <a href="/cookie_policy" className={classes.phoneLinks}>
                    Cookie Policy
                  </a>
                </div>
              </Grid>
              <Grid item sm={6} className={classes.mobilePoweredBy}>
                <div>
                  <a
                    href="https://www.jerseywatch.com/?utm_source=jw_wa"
                    rel="nofollow"
                  >
                    <span style={{ fontSize: 14 }}>Website Powered By</span>
                    <br />
                    <div
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <span style={{ fontSize: 18 }}>Jersey Watch</span>
                      <img
                        src={jwTrophyOnly}
                        style={{ width: 30, height: 30, marginLeft: 4 }}
                        alt="Jersey Watch"
                      />
                    </div>
                  </a>
                </div>
              </Grid>
            </Grid>
          )}
        </div>
      </Hidden>
      <Hidden smDown>
        {/* desktop */}
        <Grid className={css.container} container>
          <Grid item xs={12} md={6}>
            © {copyrightName} |{' '}
            <a href="/terms_of_use" className={css.simpleLinks}>
              Terms Of Use
            </a>{' '}
            |{' '}
            <a href="/privacy_policy" className={css.simpleLinks}>
              Privacy Policy
            </a>{' '}
            |{' '}
            <a href="/cookie_policy" className={css.simpleLinks}>
              Cookie Policy
            </a>
          </Grid>
          <Grid item xs={12} md={6}>
            <a
              href="https://www.jerseywatch.com/?utm_source=jw_wa"
              rel="nofollow"
              className={css.poweredBy}
              style={{ display: 'inline-flex' }}
            >
              <span>Website Powered By Jersey Watch</span>
              <img
                src={jwTrophyOnly}
                alt="Jersey Watch"
                style={{ width: 35, height: 35, marginLeft: 4 }}
              />
            </a>
          </Grid>
        </Grid>
      </Hidden>
    </div>
  );
};

JWFooter.propTypes = {
  organizationName: PropTypes.string,
};
JWFooter.defaultProps = {
  organizationName: 'Jersey Watch',
};

export default toJS(withStyles(styles)(JWFooter));
